// app/router.tsx
// TẤT CẢ routes của app tập trung ở đây
// Muốn thêm/sửa route → chỉ cần sửa file này

import { Routes, Route } from 'react-router-dom'
import {
  TrangchuPage,
  CongTrinhThietKePage,
  CongTrinhThiCongPage,
  GioiThieuPage,
  LienHePage,
  NoiThatPage,
  PrivacyPage,
  NhaVuonPage,
  NhaVuonCap4Page,
  NhaVuon2TangPage,
  NhaVuonNhieuTangPage,
  NhaPhoPage,
  BietThuPage,
  ProjectDetailPage,
  KienThucPage,
  NotFoundPage,
  TermsPage,
} from '../pages'

const AppRouter = () => (
  <Routes>
    {/* Trang chủ */}
    <Route path="/" element={<TrangchuPage />} />

    {/* Công trình thiết kế */}
    <Route path="/cong-trinh-thiet-ke" element={<CongTrinhThietKePage />} />

    {/* Nhà vườn */}
    <Route path="/nha-vuon" element={<NhaVuonPage />} />
    <Route path="/nha-vuon/nha-vuon-cap-4-nha-1-tang" element={<NhaVuonCap4Page />} />
    <Route path="/nha-vuon/2-tang" element={<NhaVuon2TangPage />} />
    <Route path="/nha-vuon/nhieu-tang" element={<NhaVuonNhieuTangPage />} />

    {/* Chi tiết công trình */}
    <Route path="/chi-tiet/:slug" element={<ProjectDetailPage />} />

    {/* Nhà phố, Biệt thự */}
    <Route path="/nha-pho"   element={<NhaPhoPage />} />
    <Route path="/biet-thu"  element={<BietThuPage />} />

    {/* Các trang khác */}
    <Route path="/cong-trinh-thi-cong" element={<CongTrinhThiCongPage />} />
    <Route path="/noi-that"            element={<NoiThatPage />} />
    <Route path="/kien-thuc"                  element={<KienThucPage category="cam-nang" />} />
    <Route path="/kien-thuc/cam-nang-xay-nha" element={<KienThucPage category="cam-nang" />} />
    <Route path="/kien-thuc/phong-thuy"       element={<KienThucPage category="phong-thuy" />} />
    <Route path="/gioi-thieu"          element={<GioiThieuPage />} />
    <Route path="/lien-he"             element={<LienHePage />} />
    <Route path="/privacy"             element={<PrivacyPage />} />
    <Route path="/terms"               element={<TermsPage />} />

    {/* Catch-all 404 Route */}
    <Route path="*"                    element={<NotFoundPage />} />
  </Routes>
)

export default AppRouter
